var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon43PostCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 18.2h-7.2c-1.1 0-2 .9-2 2v7.4c0 1.1.9 2 2 2h7.2c1.1 0 2-.9 2-2v-7.4c0-1.1-.9-2-2-2zm.5 9.4c0 .3-.2.5-.5.5h-7.2c-.3 0-.5-.2-.5-.5v-7.4c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v7.4zm1.5-16.8V14c0 1.1-.9 2-2 2h-7.2c-1.1 0-2-.9-2-2V6.6c0-1.1.9-2 2-2h5.7c.4 0 .8.3.8.8s-.3.8-.8.8h-5.7c-.3 0-.5.2-.5.5V14c0 .3.2.5.5.5h7.2c.3 0 .5-.2.5-.5v-3.2c0-.4.3-.8.8-.8s.7.4.7.8zm2.4-6.5L17.5 13c-.1.2-.4.3-.6.3-.2 0-.5-.1-.6-.3l-2.6-4.1c-.2-.3-.1-.8.2-1 .3-.2.8-.1 1 .2l2.1 3.2 6.6-7.9c.2-.4.7-.4 1-.2.3.3.4.8.1 1.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon43PostCall);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_43_PostCall.abd98e1c.svg";
export { ForwardRef as ReactComponent };